import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IRejectOrderPayload {
    id: string
    data?: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const rejectOrder = createSlice({
    name: 'order/reject',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IRejectOrderPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const rejectOrderActions = rejectOrder.actions
export default rejectOrder.reducer
